import {
  AfterViewInit,
  Directive, inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ScrollDispatcher } from "@angular/cdk/overlay";
import { Subscription } from "rxjs";

import { LorenBaseFeature } from "../loren-base-feature/loren-base-feature";
import { LorenScrollService } from "../../services/loren-scroll-service/loren-scroll.service";
import {
  LorenBreakpointObserverService
} from "../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import {
  LorenNavService
} from "../../modules/loren-nav/components/loren-nav/services/loren-nav-service/loren-nav.service";

@Directive()
export abstract class LorenBaseEntityCrudFeatureDirective<T>
  extends LorenBaseFeature
  implements OnInit, OnDestroy, AfterViewInit
{
  protected breakpointObserverService = inject(LorenBreakpointObserverService);
  protected lorenNavService = inject(LorenNavService);
  protected activatedRoute = inject(ActivatedRoute);
  protected scrollDispatcher = inject(ScrollDispatcher);
  protected scrollService = inject(LorenScrollService);

  public entities: T[] = [];
  public lastSelectedEntity: T;


  @ViewChild("entityDetails") entityDetails;
  detailsMarginTop = 0;

  private scrollSubscription: Subscription;

  // eslint-disable-next-line @angular-eslint/prefer-inject
  protected constructor(private resolveName: string) {
    super();
  }

  ngOnInit(): void {
    this.entities = this.activatedRoute.snapshot.data[this.resolveName];
  }

  onEntitySelected(entity) {
    this.lastSelectedEntity = entity;
  }

  ngAfterViewInit(): void {
    if (!this.isHandset && this.scrollService && this.scrollDispatcher) {
      const content = this.scrollService.getScrollableContent();
      const nativeElement = content.nativeElement;
      this.scrollSubscription = this.scrollDispatcher
        .ancestorScrolled(content)
        .subscribe(() => {
          this.detailsMarginTop = nativeElement.scrollTop;
        });
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
}
